export const aboutServices = [
  {
    title: "Web e web app",
    eyebrow: "Prodotto digitale",
    icon: "WEB",
    text: "Siti moderni e web app su misura, con attenzione a UX, performance e manutenzione.",
  },
  {
    title: "Soluzioni IA",
    eyebrow: "Automazione",
    icon: "AI",
    text: "Integrazioni IA pragmatiche per ridurre lavoro ripetitivo e rendere i processi piu misurabili.",
  },
  {
    title: "Prototipi e consulenza",
    eyebrow: "Validazione",
    icon: "POC",
    text: "Proof of concept rapidi, analisi tecnica e supporto fino al rilascio monitorato.",
  },
];

export const aboutTimeline = [
  {
    step: "01",
    title: "Formazione tecnica",
    points: [
      "Diploma scientifico scienze applicate con basi solide su logica e metodo.",
      "Certificazioni Cisco su Internet of Everything e Connecting Things.",
      "Ingegneria informatica come fondamento per software, dati e sistemi.",
    ],
  },
  {
    step: "02",
    title: "Esperienza operativa",
    points: [
      "Gestione dati in contesto amministrativo e studio contabile.",
      "Esperienza da Junior Developer in ambiente aziendale strutturato.",
      "Ruolo operativo in Trenitalia: rigore, responsabilita e gestione di contesti complessi.",
    ],
  },
  {
    step: "03",
    title: "Freelance e PMI",
    points: [
      "Progetti web, IA e IoT per piccole realta che cercano strumenti concreti.",
      "Approccio pratico: capire il vincolo, costruire il minimo utile, migliorare con dati reali.",
    ],
  },
];

export const techStackItems = [
  "React",
  "Angular",
  "Tailwind/CSS",
  "Node.js",
  "Firebase",
  "HTML5",
  "Java",
  "JavaScript",
  "C/C++",
  "PostgreSQL",
  "MongoDB",
  "ESP32",
  "MQTT",
  "ThingsBoard",
  "Grafana",
];
